import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const PolicySection = ({ id, icon, iconBg = 'bg-primary', title, subtitle, children }) => {
  return (
    <motion.section
      id={id}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.45, ease: [0.4, 0, 0.2, 1] }}
      className="bg-card rounded-2xl p-6 md:p-8 border border-border/50 shadow-sm"
    >
      <div className="flex items-start space-x-4 mb-6">
        <div className={`flex items-center justify-center w-11 h-11 ${iconBg} rounded-xl flex-shrink-0`}>
          <Icon name={icon} size={20} color="white" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-foreground">{title}</h2>
          {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
        </div>
      </div>
      <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
        {children}
      </div>
    </motion.section>
  );
};

export default PolicySection;
